// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iu7rh","toggle":"styles_toggle__1zfvh","preview":"styles_preview__3fNN5"};